import React, { Component } from "react";
import { Button } from "reactstrap";
import Logo from "./images/wizard-icon.png";

class Page404 extends Component {

    render() {

        return (
            <>
                <div style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    display: "flex",
                    flexDirection: "column",
                }}>
                    <div style={{
                        paddingLeft: 50,
                        paddingRight: 50,
                        paddingBottom: 10
                    }}>
                        <img src={Logo} alt={"My Logo"} />
                    </div>
                    <h5>Page not found.</h5>
                    <Button href="/" style={{ marginTop: 10, color: "#FFD770", backgroundColor: "#0F3057",
                        borderRadius: 10 }}>
                        Take me home.
                    </Button>
                </div>
            </>
        );
    }
}

export default Page404;